import { TasquetMarkdownEditor } from '../../command';
const onBackspaceDown = (e, editor) => {
    const handled = TasquetMarkdownEditor.maybeBackspaceListItem(editor);
    if (handled) {
        e.preventDefault();
    }
};
export default onBackspaceDown;
//# sourceMappingURL=onBackspaceDown.js.map